import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MapInformationService } from 'src/app/services/map-information.service';
import { DeltaworldService } from 'src/app/services/deltaworld.service';
import { EstimateService } from 'src/app/services/estimate.service';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { DxDataGridComponent, DxTreeViewComponent } from 'devextreme-angular';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { Router } from '@angular/router';
import { from } from 'rxjs';
import * as XLSX from 'xlsx';
import "jspdf-autotable";

type AOA = any[][];


declare var $: any;
@Component({
  selector: 'app-treeview-area-system',
  templateUrl: './treeview-area-system.component.html',
  styleUrls: ['./treeview-area-system.component.scss']
})
export class TreeviewAreaSystemComponent implements OnInit {
  @ViewChild('treeViewSystemArea', { static: false }) treeViewSystemArea: DxTreeViewComponent; 
  @ViewChild('treeDelete', { static: false }) treeDelete: DxTreeViewComponent; 
  @ViewChild(DxTreeViewComponent, { static: false }) treeView;
  @ViewChild(DxTreeViewComponent, { static: false }) treeView2;
  @ViewChild("gridLabor", { static: false }) gridLabor: DxDataGridComponent;
  @ViewChild("gridTemplate", { static: false }) gridTemplate: DxDataGridComponent;
  @ViewChild("gridfile", { static: false })
  gridfile: DxDataGridComponent;


  @Input() showsearch = false;
  @Input() showcheckbox = true;
  @Input() showoption = false;
  @Input() checkboxmode = 'none';
  @Input() heightParent = '100%';
  @Input() heightChild = '90%';
  @Input() expanded = true;
  @Input() systemidParent;
  @Input() Commissioning;
  @Input() FindAndReplace;
  @Input() changeOfColor; 
  @Input() graphicsCube; 


  private _areas: any[]=[];

  showDiagram:boolean = false

  openAI:boolean = false
  systemid: any;
  totalReplicate = 1;
  systemSelect: any;
  cancelButtonEditDiferenceLabor: { text: any; icon: string; elementAttr: { id: string; }; onClick: () => void; };
  areaslenght:any = 1
  @Input('areas')
  set areas(areas: any) {
    
    // this.agrupar();
    if(areas.length != undefined){
      if (areas.length > 0){
        // if (this._areas.length != areas.length){
          // this._areas = areas;
          this.userService.Get_UserSettingsCE(localStorage.getItem("customerid")).subscribe(result => {
            let obj = JSON.parse(result[0].CLIENTUSERSETTING);
            if (obj.openTreeEstimate == true) {
              this.OpenOrClose = true
              this.treeViewSystemArea.instance.expandAll()
              this.estiloCarpetas()
            } else {
              this.OpenOrClose = false
              this.treeViewSystemArea.instance.collapseAll()
              this.estiloCarpetas()
            }
  
            // localStorage.setItem('settings', result[0].CLIENTUSERSETTING);
          })
          this.agrupar2(areas);
        // }

      } else {
        this.groupItems = []
      }
    }

  }

  get areas(): any { return this._areas; }

  downloads = ["Download Trial For Visual Studio", "Download Trial For All Platforms", "Package Managers"];

  groupItems:any;

  @Output() onitemchange = new EventEmitter<any>();
  @Output() reload = new EventEmitter<any>();
  @Output() deletedSystemOrArea = new EventEmitter<any>();
  @Output() NewSystem = new EventEmitter<any>();
  @Output() gochangesystem = new EventEmitter<any>();
  @Output() changeview = new EventEmitter<any>();
  @Output() changeviewImages = new EventEmitter<any>();
  @Output() reloadData = new EventEmitter<any>();
  @Output() HideSystemsData = new EventEmitter<any>();


  @Input() estimateid: number = 0;
  @Input() estimatenamestr = '';
  @Input() projectid = '';

  areaSelect = [];
  systemTypeSelectCE = [];
  itemsNewAreaSystem = [
    {
      id: 1,
      name: "Add Areas",
      icon: "fas fa-plus icon-green",
    },
    {
      id: 2,
      name: "Add Systems",
      icon: "fas fa-plus icon-green",
    },
    // {
    //   id: 3,
    //   name: "Add Systems",
    //   icon: "fas fa-plus",
    // },
    {
      id: 5,
      name: "Import from Excel",
      icon: "fas fa-file-excel",
      onClick: () => {
        this.popupImportFromExcel = true
      },
    },
    {
      id: 3,
      name: "Import from Library",
      icon: "fas fa-file-import",
    },
   
    {
      id: 4,
      name: "Purchased in cube resources",
      icon: "fas fa-shopping-cart",
    },
   
   
  ];

  itemsDuplicateAreaSystem = [
    {
      id: 1,
      name: "Duplicate Area",
    },
    {
      id: 2,
      name: "Duplicate System",
    },
    {
      id: 3,
      name: "Replicate System",
    },
  ];

  popupReplicateSystem = false;
  saveButtonReplicateSystem: any;
  cancelButtonReplicateSystem: any;

  popupEditArea = false;
  saveButtonEditArea: any;
  cancelButtonEditArea: any;
  rowsToEditArea = [];

  popupEditSystem = false;
  saveButtonEditSystem: any;
  cancelButtonEditSystem: any;

  popupDeleteSystem = false;
  popupDeleteArea = false;
  cancelButtonDeleteEstimate: any;
  saveButtonDeleteEstimate: any;

  modelArea = {
    name: '',
    id: 0,
    active: true,
    sort: 0
  }

  modelNewSystem = {
    id: 0,
    systemid: "",
    sort: "",
    areaname: "",
    systemname: "",
    qty: 1,
    systemtype: "",
    inactive: false,
    deleted: false,
    scopeofwork: "",
    sop: "",
    excludefromsearch: "",
    controldwgname: "",
    controldwgimg: "",
    tagtext: "",
    tagnum: "",
    description: "",
  };

  popupEditAreaSystem = false;
  rowsToEditAreaSystem = [];
  saveButtonEditAreaSystem: any;
  cancelButtonEditAreaSystem: any;
  OpenOrClose:boolean = true

  profileSettings:any[];
  manageSettings:any[];

  isDuplicating:boolean = false
  itemsSelected:any[]=[]
  popupController:boolean = false
  imgSelected:any = "Not_Image"
  treeBoxValue: string[];
  // select
  taggingDatasource:any[]=[]
  treeBoxValue2: string[];
  componentModel = {
    ID:[],
    data:[]
  };

  showModalDiferencia:boolean = false

  itemsNewAreaSystemEdit = [
    {
      id: 1,
      name: "Area",
    },
    {
      id: 2,
      name: "System",
    },
  ];

  popupImportFromExcel:boolean=false

  isCollapsed: boolean = true;  // Estado inicial para controlar el ícono y las acciones

toggleExpandCollapse() {
  if (this.isCollapsed) {
    this.OpenParents();
  } else {
    this.closeParents();
  }
  this.isCollapsed = !this.isCollapsed;  // Alterna el estado
}
  constructor(
    private MapInformationService: MapInformationService,
    private estimateService: EstimateService,
    private deltaService: DeltaworldService,
    private translate:TranslateService,
    private userService: UserService,
    private toast: ToastService,
    private router: Router,
  ) {


    this.profileSettings = [
      { value: 1, name: 'Add Area', icon: 'fas fa-plus icon-green' },
      {
        value: 4, name: 'Add System', icon: 'fas fa-plus icon-green'
      },
      { value: 2, name: 'Import from Library', icon: 'fas fa-file-import' },
      { value: 10, name: 'Import IO from Excel', icon: 'fas fa-file-excel' },
      { value: 3, name: 'Delete Area', icon: 'fas fa-trash-alt' },
      { value: 5, name: 'Delete System', icon: 'fas fa-trash-alt' },
      { value: 6, name: 'Clone Area', icon: 'fas fa-clone' },
      { value: 7, name: 'Clone System', icon: 'fas fa-clone' },
      { value: 7, name: 'Replicate System', icon: 'fas fa-clone' },
      { value: 8, name: 'Edit Area', icon: 'fas fa-edit' },
      { value: 9, name: 'Edit System', icon: 'fas fa-edit' },
      // { value: 10, name: 'Move to another Area', icon: 'fas fa-exchange-alt' },
    ];

    this.manageSettings = [
      // { value: 1, name: 'Network view', icon: 'fas fa-network-wired' },
      // {
      //   value: 4, name: 'Galery View', icon: 'fas fa-eye'
      // },
      { value: 2, name: 'Find and Replace', icon: 'assets/find.png' },
      { value: 3, name: 'Change system to area', icon: 'fas fa-exchange-alt' },
    ];

   }

  ngOnInit() {

    this.cancelButtonEditDiferenceLabor = {
      text: this.translate.instant('btnClose'),
      icon:"close",
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.closeLabor()
        // this.close();
      },
    };

    // this.agrupar();


    // this.getEstimateArea(this.estimateid);

    // this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
    //   this.systemTypeSelectCE = result;
    // });

    this.cancelButtonEditAreaSystem = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupEditAreaSystem = false;
        // this.close();
      },
    };

    this.saveButtonEditAreaSystem = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        this.updateAreaSystem();
        // this.type = 1;
        // this.addNewComment();
        // this.updateNetworkConfiguration();
      },
    };


    this.cancelButtonDeleteEstimate = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupDeleteSystem = false;
        this.popupDeleteArea = false;
        this.componentModel.ID = []
        // this.close();
      },
    };

    this.saveButtonDeleteEstimate = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        if (this.popupDeleteSystem) {
          let data = this.getChecked();

          if (data.length == 0) {
            this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
            return;
          }

          let cantadadAEnviar = data.length;
          let cantidadEnviada = 0;


          // let reload = false
          // data.forEach(x=>{
          //   if (x.network == 1) {
          //     reload = true
          //   }
          // })
          // if (reload){
          //   this.toast.warning("The systme selected has child in network, you can´t delete it")
          //   this.reload.emit(this.estimateid);
          //   this.popupDeleteSystem = false;
          //   this.getEstimateArea(this.estimateid);
          //   return
          // } else {
            this.componentModel.ID.forEach(element => {
              this.estimateService.DeleteSystem(element).subscribe(result => {
                cantidadEnviada++;
                if (cantidadEnviada == cantadadAEnviar) {
                  this.toast.success(this.translate.instant('ModuleSystemToArea.msgDelSys'));
                  this.reload.emit(this.estimateid);
                  this.popupDeleteSystem = false;
                  this.getEstimateArea(this.estimateid);
                }
              })
            });
          // }

        }

        if (this.popupDeleteArea) {
          let data = this.getAreasChecked();

          if (data.length == 0) {
            this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
            return;
          }

          let cantadadAEnviar = data.length;
          let cantidadEnviada = 0;


          data.forEach(element => {

            this.estimateService.DeleteArea(element.originalid).subscribe(result => {
              cantidadEnviada++;

              if (cantidadEnviada == cantadadAEnviar) {
                this.toast.success(this.translate.instant('ModuleSystemToArea.msgAreDelSucc'));
                this.reload.emit(this.estimateid);
                // this.getEstimateArea(this.estimateid);
                this.popupDeleteArea = false;
                this.getEstimateArea(this.estimateid);
              }
            });

          });
        }
      },
    };

    this.cancelButtonReplicateSystem = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupReplicateSystem = false;
        // this.close();
      },
    };

    this.saveButtonReplicateSystem = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {

        let data = this.getChecked();

        if (data.length == 0) {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
          return;
        }


        if (this.totalReplicate <= 0) {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgRepNum'));
          return;
        }

        let cantadadAEnviar = data.length;
        let cantidadEnviada = 0;

        data.forEach(element => {


          this.estimateService.ReplicateeEstimateSystems(element.id, this.totalReplicate).subscribe(result => {
            // this.estimateService.duplicateImage(element.id,result[0].ID)
            // .subscribe(res1=>{
              cantidadEnviada++;
              if (cantidadEnviada == cantadadAEnviar) {
                this.toast.success(this.translate.instant('ModuleSystemToArea.msgRepSucc'));
                this.reload.emit(this.estimateid);
                this.totalReplicate = 0;
                this.popupReplicateSystem = false;
              }
            })
          // })
        });
      },
    };

    this.cancelButtonEditArea = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupEditArea = false;
        // this.close();
      },
    };

    this.saveButtonEditArea = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        // this.type = 1;
        // this.addNewComment();
        //this.updateNetworkConfiguration();
        this.insertArea();
      },
    };

    this.cancelButtonEditSystem = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupEditSystem = false;
        // this.close();
      },
    };

    this.saveButtonEditSystem = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        this.SaveSystem()
      },
    };

    // this.agruparItems(this.areas);
  }

  closeLabor(){
    this.showModalDiferencia = false
    this.reloadData.emit(this.estimateid);
  }

  SaveSystem(){
    
    let hasError = false;
    let erros = [];
    if (!this.modelNewSystem.areaname) {
      hasError = true;
      erros.push("Please select area.");
    }

    if (!this.modelNewSystem.systemname) {
      hasError = true;
      erros.push("Please enter system name.");
    }

    if (hasError) {
      this.toast.warning(erros.join(","));
      return;
    }

    this.estimateService
      .Insert_EstimateCreateNewSystemCE(
        this.estimateid,
        0,
        this.modelNewSystem.sort,
        this.modelNewSystem.areaname,
        this.modelNewSystem.systemname,
        this.modelNewSystem.qty,
        this.modelNewSystem.systemtype[0] != undefined ? this.modelNewSystem.systemtype[0] : this.modelNewSystem.systemtype,
        false, // inactive
        false, // deleted
        this.modelNewSystem.scopeofwork,
        this.modelNewSystem.sop,
        this.modelNewSystem.excludefromsearch,
        this.modelNewSystem.controldwgname,
        this.modelNewSystem.controldwgimg,
        this.modelNewSystem.tagtext,
        this.modelNewSystem.tagnum,
        this.modelNewSystem.description
      )
      .subscribe((r) => {
        this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysCreSucc'));
        this.popupEditSystem = false;
        this.reload.emit(this.estimateid);
        this.NewSystem.emit(r[0].resultID);
        this.modelNewSystem = {
          id: 0,
          systemid: this.systemid,
          sort: "",
          areaname: "",
          systemname: "",
          qty: 1,
          systemtype: "",
          inactive: false,
          deleted: false,
          scopeofwork: "",
          sop: "",
          excludefromsearch: "",
          controldwgname: "",
          controldwgimg: "",
          tagtext: "",
          tagnum: "",
          description: "",
        }
      });
  }

  getEstimateArea(id) {
    this.deltaService.GetEstimateAreaList(id).subscribe((result) => {
      this.areaSelect = result;
      if (result.length > 0){
        this.idAreaxDefault = result[0].ID
        this.dataTest = [{
          id:0,
          areaID:this.idAreaxDefault,
          systemTypeID:1,
          name:"",
          sort:1,
          qty:1,
          sytemOrigin:null
        }]
      }
    });
  }

  insertArea() {
    let cantidadAEnviar = this.rowsToEditArea.length;
    let cantidadEnviada = 0;

    this.rowsToEditArea.forEach(item => {
      this.MapInformationService.SaveInfoSites({
        method: "Insert_EstimateAreaCE",
        estimateid: this.estimateid,
        name: item.name,
        id: item.id,
        sort: item.sort,
        inactive: !item.active,
        alternate: item.alternate == true ? 1 : 0,
      })
      // this.estimateService
      //   .Insert_EstimateAreaCE(this.estimateid, item.name, item.id, item.sort, item.active)
        .subscribe((result) => {
          cantidadEnviada++;
          if (cantidadEnviada == cantidadAEnviar) {
            this.resetModelArea();
            this.popupEditArea = false;
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgAreSucc'));
            this.reload.emit(this.estimateid);
            this.getEstimateArea(this.estimateid);
          }
        });
    })
  }

  getSystemArea() {
    this.deltaService.GetSystemArea(this.estimateid).subscribe(result => {
      let areas = result.map(x => {
        x.SystemActive = !x.SystemActive;
        return x;
      });
      this.agrupar2(areas)
    });
  }

  getSystemType() {

    this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
      this.systemTypeSelectCE = result;
    });
  }

  getAreaSystemToEdit(obj) {

    if (this.Commissioning == "Commissioning") {

      let nodes = this.getChecked();

      if (nodes.length == 1) {
        this.getEstimateArea(this.estimateid)
        this.getSystemType()
        this.popupController = true
        return false
      }

      if (obj.itemData.id == 1) {
        this.rowsToEditArea = [];
        let nodes = this.getAreasChecked();

        if (nodes && nodes.length > 0) {
          // this.modelArea.name = nodes.areaname;
          // this.modelArea.id = nodes.originalid;
          // this.modelArea.sort = nodes.sort;
          // this.modelArea.active = nodes.areaactive;
          nodes.forEach(node => {
            let AlternateTrueOrFalse = node.Alternate == 1 ? true : false
            this.rowsToEditArea.push({
              name: node.areaname,
              id: node.originalid,
              active: node.areaactive,
              sort: node.sort,
              alternate: AlternateTrueOrFalse,
            })
          });
          this.popupEditArea = true;

        }
      }
      else if (obj.itemData.id == 2) {
        let nodes = this.getChecked();

        this.estimateService
          .GetEstimateAreaSystemInfoCE(nodes.map((x) => x.id).join(","))
          .subscribe((result) => {

            this.rowsToEditAreaSystem = result.map((x) => {
              x.Active = !x.Active;
              x.MarkLib = !x.MarkLib;
              return x;
            });

            // this.customheight = "70%";
            setTimeout(() => {
              this.popupEditAreaSystem = true;
              // this.customheight = "auto";
            }, 20);
          });
      }
    } else {
      if (obj.itemData.id == 1) {
        this.rowsToEditArea = [];
        let nodes = this.getAreasChecked();

        
        if (nodes && nodes.length > 0) {
          // this.modelArea.name = nodes.areaname;
          // this.modelArea.id = nodes.originalid;
          // this.modelArea.sort = nodes.sort;
          // this.modelArea.active = nodes.areaactive;

          nodes.forEach(node => {
            let AlternateTrueOrFalse = node.Alternate == 1 ? true : false
            this.rowsToEditArea.push({
              name: node.areaname,
              id: node.originalid,
              active: node.areaactive,
              sort: node.sort,
              alternate: AlternateTrueOrFalse,
            })
          });
          this.popupEditArea = true;

        }
      }
      else if (obj.itemData.id == 2) {
        let nodes = this.getChecked();

        if (nodes.length == 1) {
          this.systemid = nodes[0].id
          this.getEstimateArea(this.estimateid)
          this.getSystemType()
          this.popupController = true
          return false
        }

        this.idsSystem = nodes.map((x) => x.id).join(",")
        setTimeout(() => {
          this.popupEditAreaSystem = true;
          // this.customheight = "auto";
        }, 20);
      }
    }


  }

  reloadSystems(d){
    this.reload.emit(this.estimateid);
  }

  updateAreaSystem() {
    let cantidadLlamadas = this.rowsToEditAreaSystem.length;
    let cantidadTerminada = 0;

    this.rowsToEditAreaSystem.forEach((item) => {
      this.estimateService
        .Upadte_EstimateAreaSystemCE(
          item.ID,
          item.ID,
          item.SORT,
          item.AreaName,
          item.SystemName,
          item.QTY,
          item.SystemTypeid,
          !item.Active, // Ponemos el caso contrario porqu eel campo se llama inactive en bd y active en el front
          false, //deleted
          "", //scope
          item.SOP,
          item.MarkLib == true ? 0 : 1, // Ponemos el caso contrario porque el campo es diferente en bd y active en el front
          item.Control_Drawing,
          "", // img
          item.TAGTEXT,
          item.TAGNUM,
          item.DESCRIPTION
        )
        .subscribe((result) => {
          cantidadTerminada++;

          if (cantidadTerminada >= cantidadLlamadas) {
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgUpdSucc'));
            this.popupEditAreaSystem = false;
            this.reload.emit(this.estimateid);
          }
        });
    });
  }


  goToImportFromLibrary() {

    localStorage.removeItem("systemidTree")
    // localStorage.removeItem("fromLibrary")
    if (this.systemid != undefined){
      localStorage.setItem("systemidTree", this.systemid.toString())
    }
    // localStorage.setItem("fromLibrary", "Yes")

    this.router.navigateByUrl(
      `/Estimates/import-from-library?estimateid=${this.estimateid}&project=${this.estimatenamestr}&systemid=${this.systemid}`
    );
  }

  changeActiveSystem(obj) {

    this.rowsToEditAreaSystem = this.rowsToEditAreaSystem.map(x => {
      x.Active = obj.value;

      return x;
    });
  }

  changeMarkLibSystem(obj) {

    this.rowsToEditAreaSystem = this.rowsToEditAreaSystem.map(x => {
      x.MarkLib = obj.value;

      return x;
    });
  }

  resetModelArea() {
    this.modelArea = {
      name: '',
      id: 0,
      sort: 0,
      active: true
    }

    this.popupEditArea = false
  }


  popupNewSystem:boolean=false

  onItemClickNewAreaSystem(obj) {
    if (obj.itemData.id == 1) {
      // this.rowsToEditArea = [];
      // this.popupEditArea = true;
      // this.rowsToEditArea.push({
      //   name: '',
      //   id: 0,
      //   active: true,
      //   sort: 0,
      //   alternate: true
      // })
      this.openNewAreas()
    } else if (obj.itemData.id == 2) {
      // this.getEstimateArea(this.estimateid);
      // this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
      //   this.systemTypeSelectCE = result;
      //   this.popupEditSystem = true;
      // });
      this.openNewSystems()
    } else if (obj.itemData.id == 3) {
      this.goToImportFromLibrary()
    } else if (obj.itemData.id == 4) {

      console.log("Aqui")
      

      localStorage.setItem("SystemIDSelected", this.systemid.toString())
      localStorage.setItem("estimateIDSelected", this.estimateid.toString())
      localStorage.setItem("estimatenamestrSelected", this.estimatenamestr.toString())
      localStorage.setItem("projectIDSelected", this.projectid.toString())
      localStorage.removeItem("fromCommissioning")

        

      this.router.navigateByUrl(`/applications`)

    }
  }

  onItemClickDuplicateAreaSystem(obj) {


    if (obj.itemData.id == 1) {
      // this.popupEditArea = true;
      
      let data = this.getAreasChecked();

      if (data.length == 0) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
        return;
      }

      let cantadadAEnviar = data.length;
      let cantidadEnviada = 0;



      data.forEach(element => {

        this.estimateService.Insert_AreaDuplicate(element.originalid, this.estimateid).subscribe(result => {
          // this.estimateService.duplicateImage(element.id,result[0].ID)
          // .subscribe(res1=>{
            cantidadEnviada++;

            if (cantidadEnviada == cantadadAEnviar) {
              this.toast.success(this.translate.instant('ModuleSystemToArea.msgArDupSucc'));
              this.reload.emit(this.estimateid);
            }

          // })
        });

      });
    } else if (obj.itemData.id == 2) {

      let data = this.getChecked();

      if (data.length == 0) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
        return;
      }

      let cantadadAEnviar = data.length;
      let cantidadEnviada = 0;



      data.forEach(element => {

        this.estimateService.DuplicateSystemSingle(element.areaid, element.id).subscribe(result => {
          this.estimateService.duplicateImage(element.id,result[0].ID)
          .subscribe(res1=>{
            cantidadEnviada++;
            if (cantidadEnviada == cantadadAEnviar) {
              this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysDupSucc'));
              this.reload.emit(this.estimateid);
            }
          })
        })
      });
      // this.popupEditSystem = true;
      // this.customheight = "70%";
      // setTimeout(() => {
      //   this.customheight = "auto";
      // }, 20);
    } else if (obj.itemData.id == 3) {
      let data = this.getChecked();

      if (data.length == 0) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
        return;
      }


      if (this.totalReplicate <= 0) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgRepNum'));
        return;
      }

      this.popupReplicateSystem = true;
    }
  }

  onItemClickDeleteOrDuplicateAreaSystem(obj,duplicar:boolean=false) {

    this.isDuplicating = duplicar


    if (obj.itemData.id == 1) {
      // this.popupEditArea = true;

      const data = this.getAreasChecked();
      this.componentModel.data = this.getAreasChecked();

      if (this.componentModel.data.length > 0) {
        for (let i = 0; i < this.componentModel.data.length; i++) {
          this.componentModel.data[i].key = this.componentModel.data[i].originalid
        }
      }

      data.forEach(x=>{
        this.componentModel.ID.push(x.key)
      })
      
      if (this.componentModel.ID.length > 0) {
        this.popupDeleteArea = true;
        setTimeout(() => {
          if (this.treeDelete != undefined) {
            this.componentModel.ID.forEach(x=>{
              this.treeDelete.instance.selectItem(x)
            })
          }
        }, 2000);
      } else {
        this.toast.warning("You must select an area")

      }


    } else if (obj.itemData.id == 2) {
      this.componentModel.ID = this.treeViewSystemArea.instance.getSelectedNodeKeys().filter(x=> x >= 1 )
      this.componentModel.data = this.treeViewSystemArea.instance.getSelectedNodes().filter(x=> x.key >= 1 )
        
        if (this.componentModel.ID.length > 0) {
          this.popupDeleteSystem = true;
          setTimeout(() => {
            if (this.treeDelete != undefined) {
              this.componentModel.ID.forEach(x=>{
                this.treeDelete.instance.selectItem(x)
              })
            }
          }, 2000);
        } else {
          this.toast.warning("You must select a system")
        }
    } else if (obj.itemData.id == 3) {

      this.componentModel.ID = this.treeViewSystemArea.instance.getSelectedNodeKeys().filter(x=> x >= 1 )
      this.componentModel.data = this.treeViewSystemArea.instance.getSelectedNodes().filter(x=> x.key >= 1 )


      if (this.componentModel.ID.length > 0) {
        this.popupReplicateSystem = true;
        setTimeout(() => {
          if (this.treeDelete != undefined) {
            this.componentModel.ID.forEach(x=>{
              this.treeDelete.instance.selectItem(x)
            })
          }
        }, 1000);
      } else {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));  
      }
    }

  }

  clearNewSystem() {
    this.modelNewSystem = {
      id: 0,
      systemid: "",
      sort: "",
      areaname: "",
      systemname: "",
      qty: 1,
      systemtype: "",
      inactive: false,
      deleted: false,
      scopeofwork: "",
      sop: "",
      excludefromsearch: "",
      controldwgname: "",
      controldwgimg: "",
      tagtext: "",
      tagnum: "",
      description: "",
    };

    this.popupEditSystem = false;
  }

  goToFindAndReplace() {
    this.router.navigateByUrl(
      `/Estimates/find-replace?estimateid=${this.estimateid}&project=${this.estimatenamestr}&VieneDe=Comissioning`
    );
  }

  changeSystem() {
    this.gochangesystem.emit()
  }

  onItemClick(e) {
    console.log(e.itemData.name)
    switch (e.itemData.name) {
      case "Add Area":
        this.openNewAreas()
      break
      case "Add System":
        this.openNewSystems()
      break
      case "Import from Excel":
        this.popupImportFromExcel = true
      break
      case "Import IO from Excel":
        this.popupImportFromExcel = true
      break
      case "Import from Library":
        this.goToImportFromLibrary()
      break
      case "Delete Area":
        this.popupDeleteArea = true;
        const dataArea = this.getAreasChecked();
        this.componentModel.data = this.getAreasChecked();

        if (this.componentModel.data.length > 0) {
          for (let i = 0; i < this.componentModel.data.length; i++) {
            this.componentModel.data[i].key = this.componentModel.data[i].originalid
          }
        }

        dataArea.forEach(x=>{
          this.componentModel.ID.push(x.key)
        })
        
        if (this.componentModel.ID.length > 0) {
          this.popupDeleteArea = true;
          setTimeout(() => {
            if (this.treeDelete != undefined) {
              this.componentModel.ID.forEach(x=>{
                this.treeDelete.instance.selectItem(x)
              })
            }
          }, 2000);
        } else {
          this.toast.warning("You must select an area")

        }
      break
      case "Delete System":
        this.popupDeleteSystem = true;
        this.componentModel.ID = this.treeViewSystemArea.instance.getSelectedNodeKeys().filter(x=> x >= 1 )
        this.componentModel.data = this.treeViewSystemArea.instance.getSelectedNodes().filter(x=> x.key >= 1 )
          
          if (this.componentModel.ID.length > 0) {
            this.popupDeleteSystem = true;
            setTimeout(() => {
              if (this.treeDelete != undefined) {
                this.componentModel.ID.forEach(x=>{
                  this.treeDelete.instance.selectItem(x)
                })
              }
            }, 2000);
          } else {
            this.toast.warning("You must select a system")
          }
      break
      case "Clone Area":
        let data = this.getAreasChecked();

        if (data.length == 0) {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
          return;
        }

        let cantadadAEnviar = data.length;
        let cantidadEnviada = 0;



        data.forEach(element => {

          this.estimateService.Insert_AreaDuplicate(element.originalid, this.estimateid).subscribe(result => {
            // this.estimateService.duplicateImage(element.id,result[0].ID)
            // .subscribe(res1=>{
              cantidadEnviada++;

              if (cantidadEnviada == cantadadAEnviar) {
                this.toast.success(this.translate.instant('ModuleSystemToArea.msgArDupSucc'));
                this.reload.emit(this.estimateid);
              }

            // })
          });

        });
      break
      case "Clone System":
        let data1 = this.getChecked();

        if (data1.length == 0) {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
          return;
        }

        let cantadadAEnviar1 = data1.length;
        let cantidadEnviada1 = 0;



        data1.forEach(element => {

          this.estimateService.DuplicateSystemSingle(element.areaid, element.id).subscribe(result => {
            this.estimateService.duplicateImage(element.id,result[0].ID)
            .subscribe(res1=>{
              cantidadEnviada1++;
              if (cantidadEnviada1 == cantadadAEnviar1) {
                this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysDupSucc'));
                this.reload.emit(this.estimateid);
              }
            })
          })
        });
      break
      case 'Replicate System':
        this.componentModel.ID = this.treeViewSystemArea.instance.getSelectedNodeKeys().filter(x=> x >= 1 )
        this.componentModel.data = this.treeViewSystemArea.instance.getSelectedNodes().filter(x=> x.key >= 1 )


        if (this.componentModel.ID.length > 0) {
          this.popupReplicateSystem = true;
          setTimeout(() => {
            if (this.treeDelete != undefined) {
              this.componentModel.ID.forEach(x=>{
                this.treeDelete.instance.selectItem(x)
              })
            }
          }, 1000);
        } else {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));  
        }
        break
      case "Edit Area":
        this.rowsToEditArea = [];
        let nodesArea = this.getAreasChecked();

        
        if (nodesArea && nodesArea.length > 0) {
          // this.modelArea.name = nodesArea.areaname;
          // this.modelArea.id = nodesArea.originalid;
          // this.modelArea.sort = nodesArea.sort;
          // this.modelArea.active = nodesArea.areaactive;

          console.log(nodesArea)

          nodesArea.forEach(node => {
            let AlternateTrueOrFalse = node.Alternate == 1 || node.Alternate == true ? true : false
            this.rowsToEditArea.push({
              name: node.areaname,
              id: node.originalid,
              active: node.areaactive,
              sort: node.sort,
              alternate: AlternateTrueOrFalse,
            })
          });
          this.popupEditArea = true;

        }
      break

      case "Edit System":
        console.log("system")
        let nodes = this.getChecked();

        if (nodes.length == 1) {
          this.getEstimateArea(this.estimateid)
          this.getSystemType()
          this.popupController = true
          return false
        }

        // this.idsSystem = nodes.map((x) => x.id).join(",")

        // this.popupController = true


        // let nodes1 = this.getChecked();

        console.log(nodes)

        this.estimateService
          .GetEstimateAreaSystemInfoCE(nodes.map((x) => x.id).join(","))
          .subscribe((result) => {
            this.rowsToEditAreaSystem = result.map((x) => {
              x.Active = !x.Active;
              x.MarkLib = !x.MarkLib;
              return x;
            });

            console.log(this.rowsToEditAreaSystem)

            this.idsSystem = nodes.map((x) => x.id).join(",")
            setTimeout(() => {
              this.popupEditAreaSystem = true;
            }, 20);
          });

      break
    }
  }

  idsSystem:any

  onItemClickManage(e){
    switch (e.itemData.name) {
      case "Network view":

      break
      case "Galery View":

      break
      case "Find and Replace":
        this.goToFindAndReplace()
      break
      case "Change system to area":
        this.changeSystem()
      break
      case "":
      break
      case "":
      break
    }
  }

  itemSelected:any

  selectItem(item) {
    this.itemSelected = item
    if (this.systemid != item.itemData.id){ //if agregado en la optimizacion 
      this.onitemchange.emit(item.itemData);
      this.systemid = item.itemData.id > 0 ? item.itemData.id : this.systemid;
      // this.treeViewSystemArea.instance.selectItem(item.itemData.id > 0 ? item.itemData.id : this.systemid)
      $(".dx-treeview-item").removeClass("currently-active-item");
      $(item.itemElement).addClass("currently-active-item");
    }
  }

  onSelectionChange(item) {
    if (item.node.selected) {
      this.selectItem(item);
    }
  }

  agrupar() {
    const unique = [...new Set(this.areas.map(item => item.AreaName))];
    let prueba = unique.map(x => {
      let obj = {
        id: Math.random(),
        originalid: this.areas.find(a => a.AreaName == x).ID,
        sort: this.areas.find(a => a.AreaName == x).AreaSort,
        areaname: x,
        text: this.areas.find(a => a.AreaName == x).AreaSort + '-' + x,
        expanded: this.expanded,
        items: this.areas.filter(a => a.AreaName == x).map(a => {
          return {
            id: a.SystemID,
            text: a.SystemName,
            icon: a.SystemActive ? 'fas fa-folder systamactive' : 'fas fa-folder systeminactive',
            issystem: true,
            areaid: a.ID,
            path: a.ImagePath,
            SystemActive:a.SystemActive
          }
        })
      }

      return obj;
    });


    this.groupItems = prueba;

    if (this.groupItems.length > 0) {
      this.selectItem({ itemData: this.groupItems[0].items[0] });
    }

    setTimeout(() => {
      $(".systamactive").attr("style", "color:green !important");
      $(".systeminactive").attr("style", "color:red !important");
      if ($(".dx-treeview-item").length > 1) {
        $(".dx-treeview-item").removeClass("currently-active-item");
        $($(".dx-treeview-item")[1]).addClass("currently-active-item");
      }
    }, 1000);
  }

  agrupar2(arr) {
    var x = arr.reduce(function (map, node) {
      let parentid = node.ParetID;
      let nodeid = node.ID;
      map.i[nodeid] = node;
      node.items = [];
      if (parentid === null || parentid === 0) {
        map.result.push(node);
      }
      else if (parentid in map.i) {
        map.i[parentid].items.push(node);
      }
      else {
        (parentid in map.cache) ?
          map.cache[parentid].push(node) :
          map.cache[parentid] = [node];
      }
      if (nodeid in map.cache) {
        node.items = node.items.concat(map.cache[nodeid]);
        delete map.cache[nodeid];
      }
      return map;
    }, { i: {}, cache: {}, result: [] }).result;



    // debugger
    let data = x.map(item => {
      let obj
      if(this.changeOfColor == true){
         obj = {
          id: Math.random(),
          originalid: (item.ID * -1),
          sort: item.Sort,
          areaname: item.Name,
          areaactive: item.AreaActive,
          icon: 'fas fa-folder systWithOutComponent',
          text: item.Sort + '-' + item.Name,
          expanded: this.expanded,
          network: item.HASNETWORK,
          Alternate:item.Alternate,
          items: item.items.map(a => {
            return {
              id: a.ID,
              text: a.Name,
              icon: a.HASSCOMPONENTS == 1 ? 'fas fa-folder systWithComponent' : 'fas fa-folder systWithOutComponent',
              hassComponents: a.HASSCOMPONENTS,
              issystem: true,
              areaid: (a.ParetID * -1),
              path: a.ImagePath,
              Sort: a.Sort,
              SystemActive:a.SystemActive,
              network: a.HASNETWORK,
              Alternate:a.Alternate
            }
          })
        }
      } else {
         obj = {
          id: Math.random(),
          originalid: (item.ID * -1),
          sort: item.Sort,
          areaname: item.Name,
          areaactive: item.AreaActive,
          icon: item.AreaActive ? 'fas fa-folder systamactive' : 'fas fa-folder systeminactive',
          text: item.Sort + '-' + item.Name,
          expanded: this.expanded,
          network: item.HASNETWORK,
          Alternate:item.Alternate,
          items: item.items.map(a => {
            return {
              id: a.ID,
              text: a.Name,
              icon: a.AreaActive ? 'fas fa-folder systamactive' : 'fas fa-folder systeminactive',
              issystem: true,
              areaid: (a.ParetID * -1),
              path: a.ImagePath,
              Sort: a.Sort,
              SystemActive:a.SystemActive,
              network: a.HASNETWORK,
              Alternate:a.Alternate
            }
          })
        }
        
      }
 

      return obj;
    });


    this.groupItems = data;

    let first = arr.filter(x => x.ID > 0)[0];

    let child = this.groupItems.filter(x => x.items.length > 0)[0];
    if (child && child.items.length > 0) {
      if(this.systemid != undefined){
        child.items.forEach(element => {
          if(element.id == this.systemid){
            this.selectItem({ itemData: element });
          }
        });
      } else {
        this.selectItem({ itemData: child.items[0] });
      }
    }

    setTimeout(() => {
      if (this.FindAndReplace == undefined) {
        if (localStorage.getItem("systemidTree") != undefined){
          this.treeViewSystemArea.instance.unselectAll()
          this.treeViewSystemArea.instance.selectItem(Number(localStorage.getItem("systemidTree")))
          this.estiloCarpetas()
          localStorage.removeItem("systemidTree")
          setTimeout(() => {
            this.treeViewSystemArea.instance.unselectAll()
            this.SelectASystem(this.systemidParent)
          }, 2000);
        } else {
          // localStorage.removeItem("fromLibrary")
          if (this.systemidParent != 0 && this.systemidParent != undefined) {
            this.treeViewSystemArea.instance.unselectAll()
            this.treeViewSystemArea.instance.selectItem(this.systemidParent)
    
            setTimeout(() => {
              $(".systamactive").attr("style", "color:green !important");
              $(".systeminactive").attr("style", "color:red !important");
              if ($(".dx-treeview-item").length > 1) {
                $(".dx-treeview-item").removeClass("currently-active-item");
                $(this.itemSelected.itemElement).addClass("currently-active-item");
              }
            }, 800);
          }
        }
      }
      $(".systamactive").attr("style", "color:green !important");
      $(".systeminactive").attr("style", "color:red !important");
    }, 2000);

  }

  onItemExpanded(ev?:any) {
    setTimeout(() => {
      $(".systamactive").attr("style", "color:green !important")
      $(".systeminactive").attr("style", "color:red !important")
    }, 500);
  }

  getChecked() {
    let nodes = this.treeViewSystemArea.instance.getSelectedNodes();
    let data = nodes.map(x => x.itemData).filter(f => f.issystem)
    return data;
  }

  getAreasChecked() {
    let nodes = this.treeViewSystemArea.instance.getSelectedNodes();
    let data = nodes.map(x => x.itemData).filter(f => !f.issystem)
    return data
  }


  closeParents(){
    this.treeViewSystemArea.instance.collapseAll()
    this.OpenOrClose = false
    this.userService.Get_UserSettingsCE(localStorage.getItem("customerid")).subscribe(result => {
      let obj = JSON.parse(result[0].CLIENTUSERSETTING);

      obj.openTreeEstimate = false
      let data = {
        usersettings : JSON.stringify(obj)
      }
      this.userService.saveUserSettingCoor(data).subscribe(result => {
        this.estiloCarpetas()
      })
    })
  }

  estiloCarpetas(){
    if(this.changeOfColor){
      $(".systWithOutComponent").attr("style", "color:green !important");
      $(".systWithComponent").attr("style", "color:#ffc107 !important");
    } else {
      $(".systamactive").attr("style", "color:green !important");
      $(".systeminactive").attr("style", "color:red !important");
    }
    if ($(".dx-treeview-item").length > 1) {
      $(".dx-treeview-item").removeClass("currently-active-item");
      $($(".dx-treeview-item")[1]).addClass("currently-active-item");
    }
  }
// "{"dateFormat":"MM/dd/yyyy","moneyFormat":"$","startPage":"/projects","estimateidDefault":1717,"method":"update_UserSettingsCoor","DefaultSystemType":"9","map":"Santo Domingo de los Tsachilas, Ecuador"}"
 
  OpenParents(){
    this.treeViewSystemArea.instance.expandAll()
    this.OpenOrClose = true

    this.userService.Get_UserSettingsCE(localStorage.getItem("customerid")).subscribe(result => {
      let obj = JSON.parse(result[0].CLIENTUSERSETTING);

      obj.openTreeEstimate = true
      let data = {
        usersettings : JSON.stringify(obj)
      }
      this.userService.saveUserSettingCoor(data).subscribe(result => {

        this.estiloCarpetas()

      })

    })

    this.onItemExpanded()
    setTimeout(() => {
      $(".systamactive").attr("style", "color:green !important");
      $(".systeminactive").attr("style", "color:red !important");
      if ($(".dx-treeview-item").length > 1) {
        $(".dx-treeview-item").removeClass("currently-active-item");
        $($(".dx-treeview-item")[1]).addClass("currently-active-item");
      }
    }, 1000);

  }

  SelectASystem(id){
    this.treeViewSystemArea.instance.selectItem(id)

    this.estiloCarpetas()
    
    this.treeViewSystemArea.instance.expandItem(id)

  }

  syncTreeViewSelection(e) {

    var component =
      (e && e.component) || (this.treeView && this.treeView.instance);

    if (!component) return;

    if (!this.treeBoxValue) {
      component.unselectAll();
    }

    if (this.treeBoxValue) {
      this.treeBoxValue.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }
  }

  treeView_itemSelectionChanged(e) {
    // this.modelSystemInformation.systemtype = e.itemData.SystemType
    // this.modelSystemInformation.SystemTypeid = e.itemData.ID
    this.treeBoxValue = e.component.getSelectedNodeKeys();
  }

  showImagesEstimate(){
    localStorage.removeItem("systemidTree")
    if (this.systemid != undefined){
      localStorage.setItem("systemidTree", this.systemid.toString())
    }
    this.changeviewImages.emit(this.groupItems)
  }

  syncTreeViewSelection2(e) {
    var component =
      (e && e.component) || (this.treeView2 && this.treeView2.instance);

    if (!component) return;

    if (!this.treeBoxValue2) {
      component.unselectAll();
    }

    if (this.treeBoxValue2) {
      this.treeBoxValue2.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }

    if (this.componentModel.ID.length > 0) {
      setTimeout(() => {
        if (this.treeDelete != undefined) {
          this.componentModel.ID.forEach( x =>{
            if (this.popupDeleteArea){
              this.treeDelete.instance.selectItem(x.originalid * -1)
            } else {
              this.treeDelete.instance.selectItem(x)
            }
          })
        }
      }, 1000);
    }
  }

  treeView_itemSelectionChanged2(e) {
    //  && this.notAllowed == false
    if(e.itemElement != undefined){
      this.componentModel.ID = e.component.getSelectedNodeKeys()
      this.treeBoxValue2 = e.component.getSelectedNodeKeys();
    } else {
      // this.notAllowed = false
    }

    // && this.notAllowed == false && this.FirtsTime 
    if (e.itemElement != undefined){
      // this.componentModel.tagid = e.itemData.ID
      this.componentModel.ID = e.component.getSelectedNodeKeys();
      this.treeBoxValue2 = e.component.getSelectedNodeKeys();
      // this.FirtsTime = false
    }

    
  }

  cancelDelete(){
    this.popupDeleteSystem = false;
    this.popupDeleteArea = false;
    this.componentModel.ID = []
    if (this.treeDelete != undefined){
      this.treeDelete.instance.unselectAll()
    }
  }

  DeleteSystemsOrArea(){
    if (this.popupDeleteSystem) {
      let data = this.getChecked();

      // if (data.length == 0) {
      //   this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      //   return;
      // }

      let cantadadAEnviar = this.componentModel.ID.length;
      let cantidadEnviada = 0;
      this.componentModel.ID.forEach(element => {
        this.estimateService.DeleteSystem(element).subscribe(result => {
          cantidadEnviada++;
          if (cantidadEnviada == cantadadAEnviar) {
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgDelSys'));
            this.popupDeleteSystem = false;
            this.getEstimateArea(this.estimateid);
            this.cancelDelete()
            if(this.groupItems != undefined){
              if (this.groupItems.length > 0){
                if (this.groupItems[0].items.length > 0 ){
                  if (this.groupItems[0].items.length == 1){
                    this.deletedSystemOrArea.emit();
                    return false
                  }
                   let contador = 0
                  this.groupItems[0].items.forEach((x) => {
                    if (contador == 0 && x.id != element){
                      this.treeViewSystemArea.instance.selectItem(x.id)
                      this.reload.emit(this.estimateid);
                      contador++
                      return false;
                    }
                  });
                }
              }
            }
          }
        })
      });
    }

    if (this.popupDeleteArea) {
      let data = this.getAreasChecked();

      // if (data.length == 0) {
      //   this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      //   return;
      // }

      let cantadadAEnviar = this.componentModel.ID.length;
      let cantidadEnviada = 0;


      this.componentModel.ID.forEach(element => {

        this.estimateService.DeleteArea(element).subscribe(result => {
          cantidadEnviada++;

          if (cantidadEnviada == cantadadAEnviar) {
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgAreDelSucc'));
            // this.reload.emit(this.estimateid);
            // this.getEstimateArea(this.estimateid);
            this.popupDeleteArea = false;
            this.getEstimateArea(this.estimateid);
            this.cancelDelete()
            if(this.groupItems != undefined){
              if (this.groupItems.length > 0){
                if (this.groupItems.length == 1){
                  this.deletedSystemOrArea.emit();
                  return false
                }

                let contador = 0
                this.groupItems.forEach((x) => {
                  if (contador == 0 && x.originalid != element){
                    this.treeViewSystemArea.instance.selectItem(x.items[0].id)
                    this.reload.emit(this.estimateid);
                    contador++
                    return false;
                  }
                });
              }
            }
          }
        });

      });
    }
  }

  DuplicateSystemsOrArea() {

    
    if (this.popupDeleteArea) {
      // this.popupEditArea = true;
      
      let data = this.getAreasChecked();

      // if (data.length == 0) {
      //   this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      //   return;
      // }

      let cantadadAEnviar = this.componentModel.ID.length;
      let cantidadEnviada = 0;


      this.componentModel.ID.forEach(element => {


        this.estimateService.Insert_AreaDuplicate(element, this.estimateid).subscribe(result => {
          // this.estimateService.duplicateImage(element.id,result[0].ID)
          // .subscribe(res1=>{
            cantidadEnviada++;

            if (cantidadEnviada == cantadadAEnviar) {
              this.toast.success(this.translate.instant('ModuleSystemToArea.msgArDupSucc'));
              this.reload.emit(this.estimateid);
              this.popupDeleteSystem = false;
              this.cancelDelete()
            }

          // })
        });

      });
    } else if (this.popupDeleteSystem) {

      let data = []
      if (this.treeDelete != undefined) {
        let nodes = this.treeDelete.instance.getSelectedNodes();
        data = nodes.map(x => x.itemData).filter(f => f.ParetID != undefined)
      } else {
        data = this.getChecked();
      }
      let dataFinal = []
      this.componentModel.ID.forEach(x=>{
        data.forEach(y=>{
          if (x == y.id || x == y.ID){
            dataFinal.push(y)
          }

        })
      })

      // if (data.length == 0) {
      //   this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      //   return;
      // }

      let cantadadAEnviar = dataFinal.length;
      let cantidadEnviada = 0;

      dataFinal.forEach(element => {

        this.estimateService.DuplicateSystemSingle(element.areaid != undefined ? element.areaid : element.ParetID * -1, element.id != undefined ? element.id : element.ID).subscribe(result => { //debes buscar el area id
          this.estimateService.duplicateImage(element.id,result[0].ID)
          .subscribe(res1=>{
            cantidadEnviada++;
            if (cantidadEnviada == cantadadAEnviar) {
              this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysDupSucc'));
              this.reload.emit(this.estimateid);
              this.popupDeleteArea = false;
              this.cancelDelete()
            }
          })
        })
      });
    } else if (this.popupReplicateSystem) {
      // let data = this.getChecked();

      //   if (data.length == 0) {
      //     this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      //     return;
      //   }


        if (this.totalReplicate <= 0) {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgRepNum'));
          return;
        }

        let cantadadAEnviar = this.componentModel.ID.length;
        let cantidadEnviada = 0;

        this.componentModel.ID.forEach(element => {


          this.estimateService.ReplicateeEstimateSystems(element, this.totalReplicate).subscribe(result => {
            // this.estimateService.duplicateImage(element.id,result[0].ID)
            // .subscribe(res1=>{
              cantidadEnviada++;
              if (cantidadEnviada == cantadadAEnviar) {
                this.toast.success(this.translate.instant('ModuleSystemToArea.msgRepSucc'));
                this.reload.emit(this.estimateid);
                this.totalReplicate = 0;
                this.popupReplicateSystem = false;
              }
            })
          // })
        });
    }

  }

  closeReplicar(){
    this.totalReplicate = 1
     this.popupReplicateSystem = false;
     this.cancelDelete()
  }

  dataDifferenceLabor:any[]=[]

  OpenDiference(){
    let keys = this.treeViewSystemArea.instance.getSelectedNodeKeys()
    let idsFinal = []
    keys.forEach(x=>{
      if (1 < x){
        idsFinal.push(x)
      }
    })
    this.MapInformationService.SaveInfoSites({method:"GetEstimateAreaSystemSugestedLaborMultSystems", systemid:idsFinal.join(",")}) //29779
    .subscribe(resp=>{
      this.dataDifferenceLabor = resp
    })
  }

  prepareRowPartLabor(info) {
    if (info.rowType === "data") {
      if (info.data.Est_Dif == 0) {
        info.rowElement.className = info.rowElement.className + ' checkbox-none'
      }
    }
  }

  NewLabor(data){
    this.MapInformationService.SaveInfoSites({method:"CreateSystemDetailFromDetailID", detailid:data.DetailID, laborid:data.LaborID, qty:data.TotalNewQty, systemid:data.SystemID})
    .subscribe(resp=>{
      this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
      // this.showModalDiferencia = false
      this.OpenDiference()
      // this.reload.emit(this.estimateid);
    })
  }
  
  UpdateLabor(data){
    this.MapInformationService.SaveInfoSites({method:"CreateSystemDetailFromDetailID", detailid:data.DetailID, laborid:data.LaborID, qty:data.TotalNewQty, systemid:data.SystemID})
    .subscribe(resp=>{
      this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
      // this.showModalDiferencia = false
      this.OpenDiference()
      // this.reload.emit(this.estimateid);
    })
  }

  UpdateSelected(){
    const data = this.gridLabor.instance.getSelectedRowsData()
    if (data.length > 0) {
      let contador = 0
      data.forEach(info=>{
        if (info.Est_Dif != 0) {
          this.MapInformationService.SaveInfoSites({method:"CreateSystemDetailFromDetailID", detailid:info.DetailID, laborid:info.LaborID, qty:info.TotalNewQty, systemid:info.SystemID})
          .subscribe(resp=>{
            contador++
            if (contador == data.length){
              this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
              this.OpenDiference()
              // this.reload.emit(this.estimateid);
              this.gridLabor.instance.deselectAll()
            }
          })
        } else {
          contador++
          if (contador == data.length){
            this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
            this.OpenDiference()
            // this.reload.emit(this.estimateid);
            this.gridLabor.instance.deselectAll()
          }
        }
      })
    } else {
      this.toast.warning(this.translate.instant('ModuleEditEstimate.msgLeasReg'));
    }
  }
  
  UpdateAll(){
    if (this.dataDifferenceLabor.length > 0){
      let contador = 0
      this.dataDifferenceLabor.forEach(info=>{
        if (info.Est_Dif != 0) {
          this.MapInformationService.SaveInfoSites({method:"CreateSystemDetailFromDetailID", detailid:info.DetailID, laborid:info.LaborID, qty:info.TotalNewQty, systemid:info.SystemID})
          .subscribe(resp=>{
            contador++
            if (contador == this.dataDifferenceLabor.length){
              this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
              this.OpenDiference()
              // this.reload.emit(this.estimateid);
              this.gridLabor.instance.deselectAll()
            }
          })
        } else {
          contador++
          if (contador == this.dataDifferenceLabor.length){
            this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
            this.OpenDiference()
            // this.reload.emit(this.estimateid);
            this.gridLabor.instance.deselectAll()
          }
        }
      })
    } else {
      this.toast.warning(this.translate.instant('ModuleEditEstimate.msgRegUpdate'));
    }
  }

  goToTutorial(id){
    // let id = "ibtVDO1"
    // this.router.navigateByUrl()

    let url = window.location.href.split("#");
    let finalUrl = url[0] + `#/videoTutorial?numVideo=${id}`; 
    window.open(finalUrl, "_blank");

  }

  dataTest:any[]=[
    {
      id:0,
      areaID:1,
      systemTypeID:1,
      name:"",
      sort:1,
      qty:1,
      sytemOrigin:null
    }
  ]

  systemTypeMultipleData:any[]=[]
  idAreaxDefault:any
  openNewSystems(){
    this.popupNewSystem = true;
    this.getEstimateArea(this.estimateid)
    this.getSystemTypeMultiple()
    }

  closeAddMultipleSystem(){
    this.dataTest = [
      {
        id:0,
        areaID:this.idAreaxDefault,
        systemTypeID:1,
        name:"",
        sort:1,
        qty:1
      }
    ]
    this.onFileRemove()
    this.popupNewSystem = false

  }

  SaveSystemMultiples(){

    if (this.dataTest.length > 0){
      let contador = 0
      console.log(this.dataTest)
      let stop = false
      this.dataTest.forEach(x=>{
        if (x.areaID == undefined || x.areaID == ''){
          stop = true
        }
      })

      if (!stop){
        this.dataTest.forEach(x=>{
          
          let model = {
            method: "Insert_EstimateCreateNewSystemCE",
            id: this.estimateid,
            systemid: 0,
            sort: x.sort,
            areaname: x.areaID,
            systemname: x.name,
            qty: x.qty,
            systemtype: x.systemTypeID,
            inactive: 0,
            deleted: 0,
            scopeofwork: 0,
            sop: "",
            excludefromsearch: "",
            controldwgname: "",
            controldwgimg: "",
            tagtext: "",
            tagnum: "",
            description: "",
          };
          this.MapInformationService.SaveInfoSites(model)
          .subscribe(resp=>{
  
            if (x.base64 != undefined && x.base64 != "") {
              this.estimateService.SaveImageSystem(x.base64, resp[0].resultID).subscribe(res => {
                if (x.sytemOrigin != undefined) {
        
                  console.log(resp) 
                  this.MapInformationService.SaveInfoSites({
                    "method": "ImportintoSystemSingle",
                    "systemid": x.sytemOrigin,
                    "newsystemid": resp[0].resultID
                  })
                  .subscribe(res1 => {
                    
                    this.estimateService.duplicateImage(x.sytemOrigin,resp[0].resultID)
                    .subscribe(res1=>{

                      contador++
                      
                      if (contador == this.dataTest.length){
                        this.toast.success("Created Successfully")
                        this.popupNewSystem = false
                        this.dataTest = [
                          {
                            id:0,
                            areaID:this.idAreaxDefault,
                            systemTypeID:1,
                            name:"",
                            sort:1,
                            qty:1
                          }
                        ]
                        this.reload.emit()
                      }
                    })
      
                  })
                } else {
                  contador++
                  if (contador == this.dataTest.length){
                    this.toast.success("Created Successfully")
                    this.popupNewSystem = false
                    this.dataTest = [
                      {
                        id:0,
                        areaID:this.idAreaxDefault,
                        systemTypeID:1,
                        name:"",
                        sort:1,
                        qty:1
                      }
                    ]
                    this.reload.emit()
                  }
                }
              });
            } else {
              if (x.sytemOrigin != undefined) {
        
                console.log(resp) 
                this.MapInformationService.SaveInfoSites({
                  "method": "ImportintoSystemSingle",
                  "systemid": x.sytemOrigin,
                  "newsystemid": resp[0].resultID
                })
                .subscribe(res1 => {
                  this.estimateService.duplicateImage(x.sytemOrigin,resp[0].resultID)
                  .subscribe(res1=>{
                      contador++
                      if (contador == this.dataTest.length){
                        this.toast.success("Created Successfully")
                        this.popupNewSystem = false
                        this.dataTest = [
                          {
                            id:0,
                            areaID:this.idAreaxDefault,
                            systemTypeID:1,
                            name:"",
                            sort:1,
                            qty:1
                          }
                        ]
                        this.reload.emit()
                      }

                    })
    
                })
              } else {
                contador++
                if (contador == this.dataTest.length){
                  this.toast.success("Created Successfully")
                  this.popupNewSystem = false
                  this.dataTest = [
                    {
                      id:0,
                      areaID:this.idAreaxDefault,
                      systemTypeID:1,
                      name:"",
                      sort:1,
                      qty:1
                    }
                  ]
                  this.reload.emit()
                }
              }
            }
            
  
          })
        })
      } else {
        this.toast.warning("All records must have an assigned area")
      }
    }


  }

  newSystemMultiple(){
    let dataTempo = [...this.dataTest]
    const newSort = this.dataTest[this.dataTest.length - 1].sort + 1
    dataTempo.push({
      id:this.dataTest.length++,
      areaID:this.idAreaxDefault,
      systemTypeID:1,
      name:"",
      sort:newSort,
      qty:1
    })
    this.dataTest = dataTempo 
  }

  getSystemTypeMultiple(){
    this.MapInformationService.SaveInfoSites({method:"Get_EstimateSytemTypeCreateSystem"})
    .subscribe(resp=>{
      this.systemTypeMultipleData = resp
    })
  }


  deletesystemMultiple(data){
    if(this.dataTest.length > 1){
      const dataTempo = this.dataTest.filter(x=>x.id != data.id)
      this.dataTest = dataTempo
    }
  }

  // javascript create JSON object from two dimensional Array
  arrayToJSONObject(arr) {
    // header
    const keys = arr[0];

    // vacate keys from main array
    const newArr = arr.slice(1, arr.length);

    const formatted = [];
    const data = newArr;
    const cols = keys;
    const l = cols.length;
    for (let i = 0; i < data.length; i++) {
      const d = data[i];
      const o = {};
      for (let j = 0; j < l; j++) {
        o[cols[j]] = d[j];
      }
      formatted.push(o);
    }
    return formatted;
  }

  dataFormatted = { headers: [], data: [] };
  onFileRemove() {
    this.dataFormatted = {
      headers: [],
      data: []
    }
  }

  fileData: any[][] = [];
  onFileAdd(obj: File) {
    // this.loadingService.isLoading.next(true);

    /* wire up file reader */
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      let data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      data = data.filter(x => x.length > 0);
      this.fileData = data;
      this.dataFormatted.headers = data[0];

      this.dataFormatted.data = this.arrayToJSONObject(data);



      if (this.dataFormatted.data.length > 0) {
        let dataTempo = [...this.dataTest]
        let newid = this.dataTest[this.dataTest.length - 1].id + 1

        console.log(this.areaSelect)
        this.dataFormatted.data.forEach(x=>{
          dataTempo.push({
            id:newid++,
            areaID:this.areaSelect.some(area => area.ID === x.AreaID) ? x.AreaID : '',
            systemTypeID:x.SystemTypeID,
            name:x.SystemName,
            sort:x.Sort,
            qty:x.Qty,
            sytemOrigin:x.systemOrigin
          })
        })
        this.dataTest = dataTempo 
      }

    };
    reader.readAsBinaryString(obj);
  }




  // Area

  AreaTypeMultipleData:any[]=[]
  dataArea:any[]=[
    {
      id:0,
      name:"",
      sort:1,
      alternate:false,
    }
  ]

  popupNewArea:boolean = false
  
  openNewAreas(){
    this.popupNewArea = true;
  }

  closeAddMultipleArea(){
    this.dataArea = [
      {
        id:0,
        name:"",
        sort:1,
        alternate:false,
      }
    ]
    this.onFileRemove()
    this.popupNewArea = false

  }

  SaveAreaMultiples(){

    if (this.dataArea.length > 0){
      let contador = 0
      this.dataArea.forEach(x=>{
        
        let model = {
          method: "Insert_EstimateAreaCE",
          estimateid: this.estimateid,
          name: x.name,
          id: 0,
          sort: x.sort,
          inactive: 0,
          alternate: x.alternate == true || x.alternate == 1 || x.alternate == "1"  ? 1 : 0,
        };
        this.MapInformationService.SaveInfoSites(model)
        .subscribe(resp=>{
          contador++
          if (contador == this.dataArea.length){
            this.toast.success("Created Successfully")
            this.popupNewArea = false
            this.dataArea = [
              {
                id:0,
                name:"",
                sort:1,
                alternate:false,
              }
            ]
            this.reload.emit()
          }
        })
      })
    }


  }

  newAreaMultiple(){
    let dataTempo = [...this.dataArea]
    const newSort = this.dataArea[this.dataArea.length - 1].sort + 1
    dataTempo.push({
      id:this.dataArea.length++,
      name:"",
      sort:newSort,
      alternate:false
    })
    this.dataArea = dataTempo 
  }


  deleteAreaMultiple(data){
    if (this.dataArea.length > 1){
      const dataTempo = this.dataArea.filter(x=>x.id != data.id)
      this.dataArea = dataTempo
    }
  }

  onFileAddAreas(obj: File) {
    // this.loadingService.isLoading.next(true);

    /* wire up file reader */
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      let data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      data = data.filter(x => x.length > 0);
      this.fileData = data;
      this.dataFormatted.headers = data[0];

      this.dataFormatted.data = this.arrayToJSONObject(data);



      if (this.dataFormatted.data.length > 0) {
        let dataTempo = [...this.dataArea]
        let newid = this.dataArea[this.dataArea.length - 1].id + 1

        this.dataFormatted.data.forEach(x=>{
          dataTempo.push({
            id:newid++,
            name:x.Name,
            sort:x.Sort,
            alternate:x.isAlternate
          })
        })
        this.dataArea = dataTempo 
      }

    };
    reader.readAsBinaryString(obj);
  }


  refreshTree(){
    this.reload.emit()
  }

  selectfirtsArea(){
  }

  dataSystemSelected:any

  OpenNewAI(dataSystem){
    this.openAI = true
    this.dataSystemSelected = dataSystem
  }

  hidden(){
    this.openAI = false
  }


  returnImage(datasystem){
    
    this.dataTest.map(x=>{
      x = datasystem
      return x
    })
    this.toast.success("Image loaded successfully")
  }

  eliminarFoto(datasystem){
    
    this.dataTest.map(x=>{
      x = datasystem
      return x
    })
    this.toast.success("Image deleted successfully")
  }

  AsignarSystem(datasystem){
    console.log(datasystem)
    console.log(this.dataTest)
    this.dataTest.map(x=>{
      x = datasystem
      return x
    })
    this.toast.success("Components loaded successfully")
  }



  modal:boolean = false
  title:any = ""


  componetsIDS:any[]=[]

  importComponentFromLibrary(dataSystem){
    this.modal = true
    this.dataSystemSelected = dataSystem

  }

  hiddenImportLibrary(data){
    console.log(data)
    this.modal= false
  }



  validateFile() {
    this.dataFormatted.data.forEach(x => {
      this.estimateService.Get_EstimateAreaSystemDetailsImportCE(x.PARTNUMBER, x.APPNOTES, x.POINTTYPE).subscribe(result => {
        let obj = result[0];
        if (obj) {
          x.FlagApp_Note = obj.App_Note;
          x.FlagPart_Number = obj.Part_Number;
          x.FlagPoint_Type = obj.Point_Type;
        }

      });
    });
  }
  // javascript create JSON object from two dimensional Array
  arrayToJSONObject2(arr) {
    // header
    const keys = arr[0];

    // vacate keys from main array
    const newArr = arr.slice(1, arr.length);

    const formatted = [];
    const data = newArr;
    const cols = keys;
    const l = cols.length;
    for (let i = 0; i < data.length; i++) {
      const d = data[i];
      const o = {};
      for (let j = 0; j < l; j++) {
        o[cols[j]] = d[j];
      }
      formatted.push(o);
    }
    return formatted;
  }

  onFileRemove2() {
    this.dataFormatted = {
      headers: [],
      data: []
    }
  }

  onFileAdd2(obj: File) {

    /* wire up file reader */
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      let data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      data = data.filter(x => x.length > 0);
      this.fileData = data;
      this.dataFormatted.headers = data[0];

      this.dataFormatted.data = this.arrayToJSONObject2(data);
      this.validateFile();

    };
    reader.readAsBinaryString(obj);
  }

  uploadFile() {
    let data = this.gridfile.instance.getVisibleRows().map(x => x.data);

    let invalid = data.some(x => !x.TAG || !x.QTY || !x.POINTTYPE || !x.PARTNUMBER || !x.APPNOTES);

    if (invalid) {
      this.toast.warning(this.translate.instant('ModuleEditEstimate.msgValues'));
      return;
    }

    let cantidadAEnviar = data.length;
    let cantidadEnviada = 0;

    data.forEach(element => {
      this.estimateService.Insert_EstimateAreaSystemDetails(
        element.QTY,
        element.PARTNUMBER,
        element.APPNOTES,
        element.TAG,
        element.POINTTYPE,
        element.POINTNUMBER,
        element.SYSTEMID,
        0
      ).subscribe(x => {
        cantidadEnviada++;

        if (cantidadEnviada == cantidadAEnviar) {
          this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
          this.popupImportFromExcel = false;
          this.onFileRemove()
          // this.updateEstimate({
          //   selectedItem: {
          //     PROJECT_NAME: this.estimatenamestr,
          //     ID: this.estimateid
          //   }
          // });
          this.reload.emit()
        }
      });
    });
  }


  reloadDataMaster(){
    this.reload.emit()
  }

  showpopupSystems:boolean = false
  dataTemplate:any[]=[]
  showSystems(){
    this.MapInformationService.SaveInfoSites({method:"GetSystemTemplate"})
    .subscribe(resp=>{
      console.log(resp)
      this.dataTemplate = resp
      this.showpopupSystems = true
    })
  }


  getTemplate(){
    this.MapInformationService.SaveInfoSites({method:"GetSystemTemplate"})
    .subscribe(resp=>{
      console.log(resp)
      console.log(this.groupItems)
      let idArea = 0
      if (this.groupItems.length > 0){
        idArea = this.groupItems[0].originalid
      }

      if (resp.length > 0){
        let dataTempo = []
        resp.forEach(x=>{
          dataTempo.push({
            id:x.ID,
            areaID:idArea,
            systemTypeID:x.SYSTEMTYPE,
            name:x.SYSTEMNAME,
            sort:0,
            qty:1,
            sytemOrigin:x.COPYFROMSYSTEM == 0 || x.COPYFROMSYSTEM == undefined ? null : x.COPYFROMSYSTEM
          })
        })
        this.dataTest = dataTempo 
      } else {
        this.toast.warning("You don´t have systems template")
      }
    })
  }

  

  closeModalTempla(){
    this.showpopupSystems = false
    this.gridTemplate.instance.deselectAll()
  }

  insertData(){
    const resp = this.gridTemplate.instance.getSelectedRowsData()

    if (resp.length > 0){
      let dataTempo = []
      console.log(this.groupItems)
      let idArea = 0
      if (this.groupItems.length > 0){
        idArea = this.groupItems[0].originalid
      }
      resp.forEach((x, index)=>{
        dataTempo.push({
          id:x.ID,
          areaID:idArea,
          systemTypeID:x.SYSTEMTYPE,
          name:x.SYSTEMNAME,
          sort:x.SORT == undefined ? index : x.SORT,
          qty:1,
          sytemOrigin:x.COPYFROMSYSTEM == 0 || x.COPYFROMSYSTEM == undefined ? null : x.COPYFROMSYSTEM
        })
      })
      this.dataTest = dataTempo 
      this.closeModalTempla()
    } else {
      this.toast.warning("You don´t have systems template")
    }
  }

  onCleanClick(item){
    console.log(item)
    console.log(this.dataTest)
    this.dataTest.forEach(x=>{
      if (x.id == item.id){
        x.sytemOrigin = null
      }
    })
  }

  updateMultiplesystemsGrid(){
    let nodes = this.getChecked();

        if (nodes.length == 1) {
          this.systemid = nodes[0].id
          this.getEstimateArea(this.estimateid)
          this.getSystemType()
          this.popupController = true
          return false
        }

        this.idsSystem = nodes.map((x) => x.id).join(",")
        setTimeout(() => {
          this.popupEditAreaSystem = true;
          // this.customheight = "auto";
        }, 20);
  }


  openSaveTemplate:boolean = false
  saveAsTemplate(){
    this.openSaveTemplate = true
  }

  SaveTemplate(){


  this.MapInformationService.SaveInfoSites({method:"DeleteSystemTemplate"})
  .subscribe(resp=>{
    let contador = 0
      this.dataTest.forEach((x, index)=>{
        const dataFinal = {
          isfirst:index == 0 ? 1 : 0,
          copyfrom:x.sytemOrigin,
          systemname:x.name,
          systemtypeid:x.systemTypeID,
          sort:x.sort,
          method:"SaveSystemTemplate"
        }
  
        this.MapInformationService.SaveInfoSites(dataFinal)
        .subscribe(resp=>{
          contador++
          if (contador == this.dataTest.length) {
            this.toast.success("Template Saved Successfully")
            this.openSaveTemplate = false
            // this.getTemplate()
          }
        })
  
      })
    })
  }


  hideSystem(){
    this.HideSystemsData.emit()
  }

}

